import React, { useState, createContext } from 'react';
import { Navigation, Slider, UnorderedList } from './TabGroup.style';
export default function TabGroup(_a) {
    var children = _a.children, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.onSelect, onSelect = _c === void 0 ? function () { } : _c;
    var _d = useState({ width: 0, left: 0 }), sliderPosition = _d[0], setSliderPosition = _d[1];
    function handleChildren() {
        return toReactElementArray(children).map(function (child, index) {
            var childToClone = child.type === React.Fragment ? child.props.children : child;
            if (!!childToClone.props === false) {
                return null;
            }
            return React.cloneElement(childToClone, {
                key: index,
                active: childToClone.props.value === value,
            });
        });
    }
    return (React.createElement(TabGroupContext.Provider, { value: { onSelect: onSelect, setSliderPosition: setSliderPosition } },
        React.createElement(Navigation, null,
            React.createElement(UnorderedList, null, handleChildren()),
            React.createElement(Slider, { left: sliderPosition.left, width: sliderPosition.width }))));
}
function toReactElementArray(children) {
    if (!children)
        return [];
    if (Array.isArray(children))
        return children;
    return [children];
}
export var TabGroupContext = createContext({
    onSelect: function () { },
    setSliderPosition: function () { },
});
//# sourceMappingURL=TabGroup.js.map